import React from 'react';
import { SkeletonLine, SkeletonCircle, Box } from '@wix/design-system';
export function NarrowAppBoxSkeleton({ className }) {
    return (React.createElement(Box, { className: className, direction: "vertical" },
        React.createElement(SkeletonCircle, { diameter: "42px" }),
        React.createElement(SkeletonLine, { width: "168px", marginTop: "6px" }),
        React.createElement(SkeletonLine, { width: "236px", marginTop: "18px" }),
        React.createElement(SkeletonLine, { width: "117px", marginTop: "6px" }),
        React.createElement(Box, { marginTop: "50px", verticalAlign: "space-between" },
            React.createElement(SkeletonLine, { width: "80px" }),
            React.createElement(SkeletonLine, { width: "60px" }))));
}
//# sourceMappingURL=narrow-app-box-skeleton.js.map